import Network from '@/services/network'
import {useQuery} from '../utils/query'

export default function handlePurchaseAndSalesReturn() {
    const network = new Network;
    const {allParams, getQueryString} = useQuery(20)

    const storePurchasesBill = (data) => {
        return network.api('post', '/inventory/purchases/return', data);
    }
    const fetchPurchaseReturnList = (query) => {
        return network.api('get', `/inventory/purchases/return${getQueryString()}`);
    }
    const fetchPurchaseReturnListByQuery = (query) => {
        return network.api('get', `/inventory/purchases/return${query}`);
    }
    const approvePurchaseReturn = (data) => {
        return network.api('post', '/inventory/purchases/return/approval', data);
    }
    const fetchPurchaseReturnBill = (purchaseReturnId, query = '') => {
        return network.api('get', `/inventory/purchases/return/${purchaseReturnId}`+query);
    }

    const updatePurchaseReturnBill = (purchaseReturnId, data) => {
        return network.api('put', `/inventory/purchases/return/${purchaseReturnId}`, data);
    }
    const fetchSalesReturnList = (query) => {
        return network.api('get', `/inventory/sales/return${query}`);
    }
    const storeSalesReturnBill = (data) => {
        return network.api('post', '/inventory/sales/return', data);
    }
    const fetchSalesReturn = (id, query) => {
        return network.api('get', `/inventory/sales/return/${id}${query}`);
    }
    const updateSalesReturnBill = (id, data) => {
        return network.api('put', `/inventory/sales/return/${id}`, data);
    }
    return {
        storePurchasesBill,
        fetchPurchaseReturnList,
        fetchPurchaseReturnListByQuery,
        approvePurchaseReturn,
        allParams,
        fetchPurchaseReturnBill,
        updatePurchaseReturnBill,
        fetchSalesReturnList,
        storeSalesReturnBill,
        fetchSalesReturn,
        updateSalesReturnBill
    }
}
